import { action, observable } from 'mobx';
import { provideSingleton } from '../utils/decorators';
import { round } from '../utils/round';
import * as ApiTypeFactory from '../models/ApiTypeFactory';
import * as ApiTypes from '../models/ApiTypesDmg';

/** Singleton für globale Eigenschaften zur Kalibrierung von Druckmessgeräten */
@provideSingleton(DmgKalibrierungStore)
export class DmgKalibrierungStore {

  @observable readOnly: boolean = false;

  @observable datensatz: ApiTypes.IDmgKalibrierungDatensatz = ApiTypeFactory.leererDatensatzDmgKalibrierung();

  @action clear() {
    this.datensatz = ApiTypeFactory.leererDatensatzDmgKalibrierung();
  }

  /** Schaltet den Store und alle damit verbundenen Eingaben in den Nur-Lesen Modus */
  @action setReadOnly(value: boolean) {
    this.readOnly = value;
  }

  /** Übernimmt bereits gespeicherte Werte wieder in die Eingabe */
  @action setMesswerte(value: Partial<ApiTypes.IDmgKalibrierungDatensatz>) {
    const { datensatz } = this;
    // JSON.parse kann an dieser Stelle nicht verwendet werden, weil Daten auch teilweise gespeichert werden können
    // Das würde dann u.U. ein Teil-Interface erzeugen, mit dem die Eingabe nicht mehr funktioniert
    if (value.version) { datensatz.version = value.version; }
    if (value.haltezeiteingehalten) { datensatz.haltezeiteingehalten = value.haltezeiteingehalten; }
    if (value.vorbelastungbisendwert) { datensatz.vorbelastungbisendwert = value.vorbelastungbisendwert; }
    if (value.zeigerart) { datensatz.zeigerart = value.zeigerart; }
    if (value.pruefortparameter) {
      if (value.pruefortparameter.beginn) { datensatz.pruefortparameter.beginn = value.pruefortparameter.beginn; }
      if (value.pruefortparameter.ende) { datensatz.pruefortparameter.ende = value.pruefortparameter.ende; }
    }
    if (value.messpunkte) {
      datensatz.messpunkte = value.messpunkte;
    }
    if (value.kalibrierbereich) {
      datensatz.kalibrierbereich = value.kalibrierbereich;
    }
  }

  @action setHalteZeitEingehalten(value: boolean) {
    this.datensatz.haltezeiteingehalten = value;
  }

  @action setVorbelastungBisEndwert(value: boolean) {
    this.datensatz.vorbelastungbisendwert = value;
  }

  /** Passt den Kalibrierbereich für die Auswertung an, der u.a. die Anzahl der Messpunkte vorgibt */
  @action setKalibrierbereich(von: number | null, bis: number | null) {
    this.datensatz.kalibrierbereich.von = von;
    this.datensatz.kalibrierbereich.bis = bis;
    if (von === null || bis === null) {
      return;
    }

    // Der gewählte Kalibrierbereich definiert die Anzahl der Schritte und die Schrittweite aus denen die Messpunkte erzeugt werden
    let schritte: number = (round(bis, 0) % 4) === 0 ? 5 : 6;
    let schrittweite: number = round(bis, 0) / (schritte - 1);

    if (schritte > this.datensatz.messpunkte.length) {
      for (let i = this.datensatz.messpunkte.length; i < schritte; i++) {
        let mp: ApiTypes.IDmgKalibrierungMesspunkt = ApiTypeFactory.leererDmgMesspunkt();
        mp.index = i + 1;
        this.datensatz.messpunkte.push(mp);
      }
    }

    if (schritte < this.datensatz.messpunkte.length) {
      this.datensatz.messpunkte = this.datensatz.messpunkte.slice(0, schritte);
    }

    // Nenndrücke berechnen
    for (let i = 0; i < this.datensatz.messpunkte.length; i++) {
      let mp = this.datensatz.messpunkte[i];
      mp.index = i + 1;
      mp.nenndruck = round(i * schrittweite, 1);
      if (i === schritte - 1) {
        // Letzten Messpunkt auf Ende des Kalibrierbereichs deckeln
        mp.nenndruck = round(bis, 1);
      }
    }

    // Bereits eingegebene Messwerte löschen
    for (let i = 0; i < this.datensatz.messpunkte.length; i++) {
      this.datensatz.messpunkte[i].m1.normal = null;
      this.datensatz.messpunkte[i].m2.normal = null;
      this.datensatz.messpunkte[i].m1.anzeige = null;
      this.datensatz.messpunkte[i].m2.anzeige = null;
    }
  }

  @action setZeigerArt(value: string) {
    this.datensatz.zeigerart = value;
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/DmgKalibrierungStore.ts